export interface PieChartsOptions {
  animate?: number;
  barColor?: string;
  lineCap?: string;
  lineWidth?: number;
  scaleColor?: boolean;
  size?: number;
  trackColor?: string;
}

const DEFAULT_OPTIONS: PieChartsOptions = {
  animate: 2000,
  barColor: "#ef1e25",
  lineCap: "square",
  lineWidth: 6,
  scaleColor: false,
  size: 160,
  trackColor: "rgba(0,0,0,0.10)"
};
export default (element: HTMLElement, options: PieChartsOptions) => {
  const { animate, ...opts } = Object.assign({}, DEFAULT_OPTIONS, options);

  const $element = $(element);
  $element.find("span, i").css({
    width: `${opts.size}px`,
    height: `${opts.size}px`,
    "line-height": `${opts.size}px`
  });
  $element.appear(() => {
    $element.easyPieChart({
      ...opts,
      animate: { duration: animate, enabled: !!animate },
      onStep: (from, to, percent) => {
        $element.find("span.percent").text(Math.round(percent));
      }
    });
  });
};
